const nextCalendarDay = (date) => {
  const nextDay = new Date(date)
  nextDay.setDate(nextDay.getDate() + 1)
  return nextDay
}

export const normalizeCalendarRange = (newRange, view) => {
  if (Array.isArray(newRange)) {
    const start = newRange[0]
    const lastVisibleDay = newRange[newRange.length - 1]

    return {
      start,
      // Day and week ranges are inclusive lists of visible calendar days.
      // The API expects an exclusive upper bound, so include the final day.
      end: nextCalendarDay(lastVisibleDay),
    }
  }

  const { start, end } = newRange

  // Month supplies an object whose end already covers its final visible day.
  // Keep that library-provided boundary intact.
  if (view === 'month' && start < end) {
    return { start, end }
  }

  if (start < end) {
    return { start, end }
  }

  return { start, end: nextCalendarDay(start) }
}
